import React, { useState } from "react";
import { LoadingContext } from "../context/LoadingContext";

export function LoadingProvider({ children }: { children: React.ReactNode }) {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <LoadingContext.Provider
      value={{
        isLoading,
        show: () => setIsLoading(true),
        hide: () => setIsLoading(false),
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
}
